import { createSlice } from '@reduxjs/toolkit'

import {
  loginUser,
  remoteLogin,
  refreshToken,
  impersonateLogin,
} from '../authorization'
import { getSchedulingEligibility } from '../scheduling'
import {
  initialState,
  entityAdapter,
} from '@sales-center/common/tenantFeatures'

const slice = createSlice({
  name: 'tenantFeatures',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(refreshToken.fulfilled, (state, { payload }) => {
      if (payload.tenantFeatures)
        entityAdapter.setAll(state, payload.tenantFeatures)
    })
    builder.addCase(loginUser.fulfilled, (state, { payload }) => {
      if (payload.tenantFeatures)
        entityAdapter.setAll(state, payload.tenantFeatures)
    })
    builder.addCase(impersonateLogin.fulfilled, (state, { payload }) => {
      if (payload.tenantFeatures)
        entityAdapter.setAll(state, payload.tenantFeatures)
    })
    builder.addCase(remoteLogin.fulfilled, (state, { payload }) => {
      if (payload.tenantFeatures)
        entityAdapter.setAll(state, payload.tenantFeatures)
    })
    builder.addCase(
      getSchedulingEligibility.fulfilled,
      (state, { payload }) => {
        state.schedulingEligibility = payload.automatedSchedulingAvailable
      },
    )
  },
})

export default slice.reducer
